export default __webpack_public_path__ + "static/media/multi_acc2.aa67ed8e.png";